import React, { useState } from "react"
import { Outlet, Navigate, useNavigate } from "react-router-dom"
import { useAuthStatus } from '../../hooks/useAuthStatus'
import toast from 'react-hot-toast';
import { FormattedMessage } from "react-intl"

const PrivateRoutes = () => {

    const { loggedIn, checkingStatus } = useAuthStatus()
    const navigate = useNavigate()

    if (checkingStatus) {
        return <div>Loading</div>
    }

    if (!loggedIn) {
        navigate('/app/login')
    }

    return (loggedIn ?
        <Outlet /> :
        <Navigate to='/app/login' />)

}

export default PrivateRoutes